<template>
  <div class="submit-counter-delete">
    <el-dialog title="提交柜面删单" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <div style="margin-bottom:16px">温馨提示：提交柜面删单前，请<el-link type="primary" :underline="false" @click="toQQ">联系客服</el-link>确认好删单费用！</div>
      <el-form ref="form" :model="form" :rules="formCheck" label-width="90px" size="small" label-position="top" :inline="false">
        <el-form-item label="分提单号" prop="houseBillIds">
          <el-select v-model="form.houseBillIds" placeholder="请输入分提单号" filterable multiple style="width: 320px">
            <el-option v-for="item in deleteList" :key="item.id" :label="item.houseBillNo" :value="item.id">
              <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                <span>{{ item.houseBillNo }}</span>
              </div>
            </el-option>
          </el-select>
          <!-- <div v-for="(item,index) in noList" :key="index" class="bill-box">
            <el-input v-model="form.houseBillIds" placeholder="请输入分提单号" style="width:320px"></el-input>
            <i class="iconfont icon-zengjiatidanhao" v-if="noList.length<5" @click="addNo(index)"></i>
            <i class="iconfont icon-shanchutidanhao" v-if="noList.length>1" @click="minusNo(index)"></i>
          </div> -->
        </el-form-item>
        <el-form-item label="删单费" prop="fee">
          <el-input v-model="form.fee" :maxlength="5" placeholder="请输入删单费" style="width:320px" class="delete-fee" @blur="val => toFixedNum(val)"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" placeholder="最多输入30个字符" style="width:672px" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="files">
          <WUpload :auto-upload="false" :headers="{ token: token }" accept=".zip,.rar,.jpg,.jpeg,.png,.pdf,.tif,.doc,.docx,.xls,.xlsx" :on-change="handleChange" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" class="submit-btn" @click="enterFee">确认</el-button>
      </div>
    </el-dialog>
    <DeleteOrderFee v-if="deleteOrderFeeVisible" :visible="deleteOrderFeeVisible" :deleteFeeData="deleteFeeData" @closeDialog="closeFee" @enterSend="enterSend" />
  </div>
</template>

<script>
import { drafts } from "@/api/index";
import { axios } from "@/request/index";
import DeleteOrderFee from './DeleteOrderFee'
var regSP = /^\S.*\S$|(^\S{0,1}\S$)/ // 检测空格

export default {
  name: "SubmitCounterDelete",
  components: {
    DeleteOrderFee
  },
  props: {
    visible: Boolean
  },
  data () {
    const regCM = /^[0-9]+$/
    const validateCM = (rule, value, callback) => {
      console.log(value)
      if (regCM.test(value) === false) {
        callback(new Error('只能输入数字'))
      } else if (!regSP.test(value)) {
        callback(new Error('首尾不能包含空格'))
      } else {
        if (regCM.test(value) === false) {
          callback(new Error('只能输入数字'))
        } else if (!regSP.test(value)) {
          callback(new Error('首尾不能包含空格'))
        } else {
          callback()
        }
      }
    }
    return {
      deleteFeeData: {
        payAmount: '',
        feeItems: []
      },
      deleteOrderFeeVisible: false,
      token: localStorage.getItem('userToken'),

      form:{
        houseBillIds: [],
        fee: '',
        remark: '',
        files: []
      },
      formCheck:{
        houseBillIds:[
          { required: true, message: '请输入分提单号', trigger: ['blur', 'change'] },
        ],
        fee: [
          { required: true, message: '请输入删单费', trigger: ['blur', 'change'] },
          { required: true, validator: validateCM, trigger: ['blur', 'change'] }
        ],
        files: [
          { required: true, message: '请上传文件', trigger: ['blur', 'change'] },
        ],
      },
      // noList:[{
      //   value:''
      // }],
      deleteList: [],
      files: [],
      fileList: []
    }
  },
  created () {
    this.getCounterDeleteHouseBillNoList()
  },
  methods: {
    closeFee(){
      this.deleteOrderFeeVisible = false
    },
    // 确认价格
    enterFee(){
      this.$refs['form'].validate((valid) => {
        if(valid){
          let arr = []
          this.deleteList.forEach(val => {
            this.form.houseBillIds.forEach(item => {
              if(val.id == item)
              arr.push({houseBillNo: val.houseBillNo})
            })
            
          })
          
          this.deleteFeeData.feeItems = arr
          this.deleteFeeData.payAmount = this.form.fee
          this.deleteOrderFeeVisible = true
        }
      })

      
    },
    enterSend(){
      const formData = new FormData()
      this.fileList.forEach((file) => {
        formData.append('files', file.raw)
      })
      // let params = { 
      //   fee: this.form.fee,
      //   remark: window.btoa(this.form.remark),
      //   formData
      // }
      const config = { headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryeiBT7bA9JKpCxEMs' }}
      axios.post(`/ccam/orders/counterDelete?fee=${this.form.fee}&remark=${btoa(encodeURIComponent(this.form.remark))}&houseBillIds=${this.form.houseBillIds}`, formData, config).then((res)=>{
        console.log(res)
        this.$message.success('柜面删单申请成功，等待客服审批～')
        this.$emit('successDelete')
      })
    },
    handleChange(file, fileList) {
      this.$refs.form.clearValidate()
      console.log(file)
      console.log(fileList)
      // this.form.files = []
      // this.fileList = []
      this.form.files = fileList

      // this.files = fileList.map(o => o.raw)
      // this.fileList = fileList.slice(-3);
      
      this.fileList = fileList
    },
    // 获取分提单号
    getCounterDeleteHouseBillNoList(){
      drafts.getCounterDeleteHouseBillNoList({
        pageNum: 1,
        pageSize: 999,
      }).then(res => {
        console.log(res)
        this.deleteList = res.records
      })
    },
    // 关闭
    closeDialog () {
      this.$emit("closeDialog")
    },
    // 联系客服
    toQQ(){
      window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true')
    },
    // addNo(index){
    //   this.noList.splice(index+1,0,{value:''})
    // },
    // minusNo(index){
    //   this.noList.splice(index,1)
    // },
    
    // 保留num位 有效数字
    toFixedNum (val) {
      let e = ''
      if (!(/(^[1-9]\d*$)/.test(Number(val.target.value)))) {
        e = Number(val.target.value)
      } else {
        e = Number(val.target.value)
      }
      this.form.fee = e.toString()
    },
  }
}
</script>

<style scoped lang="less">
.submit-counter-delete {
  color: #333333;
  font-size: 14px;
  .el-link {
    vertical-align: top;
  }
  .dialog-footer {
    text-align: right;
    margin-top: 24px;
  }
  .el-form .el-form-item {
    margin: 0 16px 16px 0;
  }
  .delete-fee {
    position: relative;
    /deep/.el-input__inner {
      padding-right: 40px;
    }
  }
  .delete-fee:after {
    content: 'U币';
    display: block;
    position: absolute;
    right: 16px;
    top: 0;
  }
  .w-upload {
    margin-top: 8px;
    width: 672px;
  }
  .bill-box {
    margin-top: 14px;
    .iconfont {
      margin-left: 24px;
      cursor: pointer;
    }
    .icon-zengjiatidanhao {
      color: #1170eb;
    }
    .icon-shanchutidanhao {
      color: #ff1212;
    }
  }
  .bill-box:first-child {
    margin-top: 0;
  }
}
</style>